<p-toast></p-toast>



<!-- <p-panel header="Add Farmer Details" [toggleable]="true" [toggleable]="true"> -->
<div class="farmer-details-card card">
    <p [style]="{'color': 'rgb(168, 32, 32)', 'font-weight': 'bold', 'font-size': '1.0rem'}">{{ 'Add Farmer Details' |
        translate }}</p>
    <div class="card dropdown-content">
        <div class="p-fluid p-formgrid grid ">
            <div class="field col-12 md:col-4">
                <label htmlFor="selectOutletMaster">{{'SELECT_OUTLET_RD'| translate}}</label>
                <div class="grid-item">
                    <p-dropdown [options]="contractorOutletList" [(ngModel)]="selectedOutlet"
                        (onChange)="onSelectOutlet()" appendTo="body" placeholder="{{ 'SELECT_OUTLET_RD'| translate }}"
                        optionLabel="Outlets"></p-dropdown>
                </div>
            </div>

            <div *ngIf="selectedOutlet" class="field col-12 md:col-4">
                <label htmlFor="selectBenefitedArea">{{'BENEFITED_AREA_(IN_ACRE)'| translate}}</label>
                <div class="grid-item">
                    <input type="text" class="readonly" readonly pInputText [(ngModel)]="selectedBenefitedArea"
                        variant="filled" />
                </div>
            </div>

            <div class="field col-12 md:col-4">
                <label htmlFor="selectOutletMaster">{{'AGREEMENT_NO'| translate}}</label>
                <div class="grid-item">
                    <input [(ngModel)]="agreementNo" pInputText type="text" />
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="selectedOutlet && agreementNo">
        <div class="p-fluid card personal-details-card">
            <form [formGroup]="personalDetailsForm" (ngSubmit)="onSubmitPersonalDetails()">
                <h5
                    [ngStyle]="{'color': 'rgb(125, 22, 22)', 'font-weight': 'bold', 'display': 'flex', 'justify-content': 'center', 'align-items': 'center'}">
                    {{'Personal Details' | translate}}</h5>

                <div class="p-fluid p-formgrid grid justify-content-left personal-details-form">
                    <div class="field col-12 md:col-4">
                        <label for="name">{{'FARMER_NAME' | translate}}</label>
                        <input id="name" type="text" pInputText formControlName="name">
                        <div *ngIf="personalDetailsForm.controls['name'].invalid && personalDetailsForm.controls['name'].touched"
                            class="p-error">
                            {{'FARMER_NAME_IS_REQUIRED' | translate}}
                        </div>
                    </div>

                    <div class="field col-12 md:col-4">
                        <label for="fatherName">{{'FATHERS_NAME' | translate}}</label>
                        <input id="fatherName" type="text" pInputText formControlName="fatherName">
                        <div *ngIf="personalDetailsForm.controls['fatherName'].invalid && personalDetailsForm.controls['fatherName'].touched"
                            class="p-error">
                            {{'FATHERS_NAME_IS_REQUIRED' | translate}}
                        </div>
                    </div>

                    <div class="field col-12 md:col-4">
                        <label htmlFor="mobileNo">{{'MOBILE_NO' | translate}}</label>
                        <input maxlength="10" pattern="^[0-9]{10}$" pKeyFilter="int" formControlName="mobileNo"
                            pInputText id="mobileNo" type="text"
                            [ngClass]="{ 'ng-invalid ng-dirty': personalDetailsForm.controls['mobileNo'].invalid && personalDetailsForm.controls['mobileNo'].touched }" />

                        <div *ngIf="personalDetailsForm.controls['mobileNo'].invalid && personalDetailsForm.controls['mobileNo'].touched"
                            class="p-error">
                            <div *ngIf="personalDetailsForm.controls['mobileNo'].errors.required">
                                {{'MOBILE_NO_IS_REQUIRED'
                                | translate}}</div>

                            <div *ngIf="personalDetailsForm.controls['mobileNo'].errors.minlength">
                                {{'MOBILE_NO_SHOULD_BE_OF_10_DIGITS' |
                                translate}}</div>
                            <div *ngIf="personalDetailsForm.controls['mobileNo'].errors.maxlength">
                                {{'MOBILE_NO_SHOULD_BE_OF_10_DIGITS' |
                                translate}}</div>
                            <div *ngIf="personalDetailsForm.controls['mobileNo'].errors.pattern">
                                {{'MBILE_NO_SHOULD_CONTAIN'
                                | translate}}</div>
                        </div>
                    </div>

                    <div class="field col-12 md:col-4">
                        <label htmlFor="mfmbNo">{{'MFMB_NO' | translate}}</label>
                        <input maxlength="8" pattern="^[0-9]{8}$" pKeyFilter="int" formControlName="mfmbNo" pInputText
                            id="block" type="text"
                            [ngClass]="{ 'ng-invalid ng-dirty': personalDetailsForm.controls['mfmbNo'].invalid && personalDetailsForm.controls['mfmbNo'].touched }" />
                        <div *ngIf="personalDetailsForm.controls['mfmbNo'].invalid && personalDetailsForm.controls['mfmbNo'].touched"
                            class="invalid-feedback">
                            <div *ngIf="personalDetailsForm.controls['mfmbNo'].errors.required">{{'MFMB_NO_REQUIRED' |
                                translate}}</div>
                            <div *ngIf="personalDetailsForm.controls['mfmbNo'].errors.minlength">
                                {{'MFMB_NO_REQUIRED_NO_IS_SHOULD_BE_OF_12_DIGITS' |
                                translate}}</div>
                            <div *ngIf="personalDetailsForm.controls['mfmbNo'].errors.maxlength">
                                {{'MFMB_NO_REQUIRED_NO_IS_SHOULD_BE_OF_12_DIGITS' |
                                translate}}</div>
                        </div>
                    </div>

                    <div class="field col-12 md:col-4">
                        <label htmlFor="block">{{'PPP_ID' | translate}}</label>
                        <input maxlength="8" formControlName="pppId" pInputText id="block" type="text"
                            [ngClass]="{ 'ng-invalid ng-dirty': personalDetailsForm.controls['pppId'].invalid && personalDetailsForm.controls['pppId'].touched }" />
                        <div *ngIf="personalDetailsForm.controls['pppId'].invalid && personalDetailsForm.controls['pppId'].touched"
                            class="invalid-feedback">
                            <div *ngIf="personalDetailsForm.controls['pppId'].errors.required">{{'PPP_ID_IS_REQUIRED' |
                                translate}}</div>
                            <div *ngIf="personalDetailsForm.controls['pppId'].errors.minlength">
                                {{'PPP_ID_SHOULD_BE_OF_8DIGITS' | translate}}</div>
                            <div *ngIf="personalDetailsForm.controls['pppId'].errors.maxlength">
                                {{'PPP_ID_SHOULD_BE_OF_8DIGITS' | translate}}</div>
                        </div>
                    </div>

                    <div class="field col-12 md:col-4">
                        <label htmlFor="block">{{'CASTE' | translate}}</label>
                        <div class="formgroup-inline">
                            <div class="field">
                                <div class="field-radiobutton mb-0">
                                    <p-radioButton formControlName="casteCode" value="1"
                                        id="IsSubsidyAvailabeYes"></p-radioButton>
                                    <label for="IsSubsidyAvailabeYes">{{'GEN' | translate}}</label>
                                </div>
                            </div>
                            <div class="field">
                                <div class="field-radiobutton mb-0">
                                    <p-radioButton formControlName="casteCode" value="2"
                                        id="IsSubsidyAvailabeYes"></p-radioButton>
                                    <label for="IsSubsidyAvailabeYes">{{'BC' | translate}}</label>
                                </div>
                            </div>
                            <div class="field">
                                <div class="field-radiobutton mb-0">
                                    <p-radioButton formControlName="casteCode" value="3"
                                        id="IsSubsidyAvailabeNo"></p-radioButton>
                                    <label for="IsSubsidyAvailabeNo">{{'SC/ST' | translate}}</label>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="personalDetailsForm.controls['casteCode'].invalid && personalDetailsForm.controls['casteCode'].touched"
                            class="invalid-feedback">
                            <div *ngIf="personalDetailsForm.controls['casteCode'].errors.required">
                                {{'CASTE_IS_REQUIRED'| translate}}</div>
                        </div>
                    </div>

                    <div class="field col-12 md:col-4">
                        <label htmlFor="villageCode">{{'VILLAGE' | translate}}</label>
                        <p-autoComplete formControlName="villageCode" placeholder="{{'SEARCH'| translate}}" id="dd"
                            [dropdown]="true" [multiple]="false" [suggestions]="filteredVillage"
                            (completeMethod)="filterVillage($event)" field="Name" value="Code"
                            [ngClass]="{ 'ng-invalid ng-dirty': personalDetailsForm.controls['villageCode'].touched  && personalDetailsForm.controls['villageCode'].errors }"></p-autoComplete>

                        <div *ngIf="personalDetailsForm.controls['villageCode'].invalid && personalDetailsForm.controls['villageCode'].touched"
                            class="p-error">
                            {{'VILLAGE_NAME_IS_REQUIRED' | translate}}
                        </div>
                    </div>

                    <div class="field col-12 md:col-4">
                        <label htmlFor="component">{{'PROPOSED_SYETEM_TO_BE_INSTALLED'| translate}}</label>

                        <!-- <p-autoComplete [(ngModel)]="selectedcompMaster" formControlName="componentMaster"
                        placeholder="{{'SEARCH'| translate}}" id="Program_Id" [dropdown]="true" [multiple]="false"
                        [suggestions]="filteredComponentMaster" (completeMethod)="filterComponentMaster($event)"
                        field="Program_Name"
                        [ngClass]="{ 'g-invalid ng-dirty': personalDetailsForm.controls['componentMaster'].invalid && personalDetailsForm.controls['componentMaster'].touched }">
                    </p-autoComplete> -->
                        <p-dropdown [options]="componentMasterList" appendTo="body" formControlName="componentMaster"
                            placeholder="{{'SEARCH'| translate}}" optionLabel="Program_Name"
                            [ngClass]="{ 'g-invalid ng-dirty': personalDetailsForm.controls['componentMaster'].invalid && personalDetailsForm.controls['componentMaster'].touched }"></p-dropdown>
                        <div *ngIf="personalDetailsForm.controls['componentMaster'].invalid && personalDetailsForm.controls['componentMaster'].touched"
                            class="invalid-feedback">
                            <div *ngIf="personalDetailsForm.controls['componentMaster'].errors.required">
                                {{'PROPOSED_SYETEM_IS_REQUIRED'| translate}}</div>
                        </div>
                    </div>

                    <div class="field col-12 md:col-4">
                        <label htmlFor="component">{{'CATEGORY_OF_FARMER'| translate}}</label>

                        <!-- <p-autoComplete [(ngModel)]="selectedFarmerCategory" formControlName="farmerCategory"
                        placeholder="{{'SEARCH'| translate}}" id="Program_Id" [dropdown]="true" [multiple]="false"
                        [suggestions]="filteredComponentMaster" (completeMethod)="filterComponentMaster($event)"
                        field="Program_Name"
                        [ngClass]="{ 'g-invalid ng-dirty': personalDetailsForm.controls['farmerCategory'].invalid && personalDetailsForm.controls['farmerCategory'].touched }">
                    </p-autoComplete> -->
                        <p-dropdown [options]="farmerCategoryList" appendTo="body" formControlName="farmerCategory"
                            placeholder="{{'SEARCH'| translate}}" optionLabel="Type"
                            [ngClass]="{ 'g-invalid ng-dirty': personalDetailsForm.controls['farmerCategory'].invalid && personalDetailsForm.controls['farmerCategory'].touched }"></p-dropdown>
                        <div *ngIf="personalDetailsForm.controls['farmerCategory'].invalid && personalDetailsForm.controls['farmerCategory'].touched"
                            class="invalid-feedback">
                            <div *ngIf="personalDetailsForm.controls['farmerCategory'].errors.required">
                                {{'COMPONENT_MASTER_IS_REQUIRED'| translate}}</div>
                        </div>
                    </div>

                    <div class="field col-12 md:col-4">
                        <label htmlFor="block">{{'AADHAR_NUMBER' | translate}}</label>
                        <input maxlength="12" pattern="^[0-9]{12}$" pKeyFilter="int" formControlName="aadharNo"
                            pInputText id="block" type="text" (input)="checkAadharNumber($event)"
                            [ngClass]="{ 'ng-invalid ng-dirty': personalDetailsForm.controls['aadharNo'].invalid && personalDetailsForm.controls['aadharNo'].touched }" />

                        <div *ngIf="personalDetailsForm.controls['aadharNo'].invalid && personalDetailsForm.controls['aadharNo'].touched"
                            class="invalid-feedback">
                            <div *ngIf="personalDetailsForm.controls['aadharNo'].errors.required">
                                {{'AADHAR_NO_IS_REQUIRED'
                                | translate}}</div>
                            <div *ngIf="personalDetailsForm.controls['aadharNo'].errors.minlength">
                                {{'AADHAR_NO_IS_SHOULD_BE_OF_12_DIGITS' |
                                translate}}</div>
                            <div *ngIf="personalDetailsForm.controls['aadharNo'].errors.maxlength">
                                {{'AADHAR_NO_IS_SHOULD_BE_OF_12_DIGITS' |
                                translate}}</div>
                            <!-- <div *ngIf="personalDetailsForm.controls['aadharNo'].errors.pattern">{{'AADHAR_NO_SHOULD_CONTAIN_ONLY_DIGITS' |
                        translate}}</div> -->
                        </div>
                    </div>

                    <div class="field col-12 md:col-5">
                        <label for="name" class="ml-2">{{'AADHAR_PHOTO' | translate}}</label>
                        <p-fileUpload accept=".jpeg,.pdf,.jpg" [customUpload]="true" #farmerAadharDocUpload
                            (uploadHandler)="onAadharUpload($event, 'aadharPhotoPath', farmerAadharDocUpload)"
                            name="myfile[]" [maxFileSize]="5000000" [multiple]="false"
                            chooseLabel="{{'CHOOSE'| translate}}" [auto]="false" [showCancelButton]="false">
                            <ng-template pTemplate="content">
                                <!-- <ul *ngIf="uploadedAadharFiles.length">
                                <li *ngFor="let file of uploadedAadharFiles">
                                    <p-image *ngIf="personalDetailsForm.controls['aadharPhotoPath'].value"
                                        [src]="personalDetailsForm.controls['aadharPhotoPath'].value" alt="Image"
                                        width="60" class="ml-2" iconPos="left"></p-image>
                                    {{ file.name }} - {{ file.size }} bytes
                                </li>
                            </ul> -->
                            </ng-template>
                        </p-fileUpload>
                        <div *ngIf="personalDetailsForm.controls['aadharPhotoPath'].invalid && personalDetailsForm.controls['aadharPhotoPath'].touched"
                            class="invalid-feedback">
                            <div *ngIf="personalDetailsForm.controls['aadharPhotoPath'].errors.required">
                                {{'AADHAR_PHOTO_IS_REQUIRED' | translate}}
                            </div>
                        </div>
                    </div>

                    <div class="field col-12 md:col-3">
                        <label htmlFor="block">{{'IS_SUBSIDY_AVAILED' | translate}}</label>
                        <div class="formgroup-inline">
                            <div class="field">
                                <div class="field-radiobutton mb-0">
                                    <p-radioButton formControlName="isSubsidyAvailabe" value="1"
                                        id="isSubsidyAvailabeYes" (onClick)="onSelectSubsidyAvail('1')"></p-radioButton>
                                    <label for="IsSubsidyAvailabeYes">{{'YES' | translate}}</label>
                                </div>
                            </div>
                            <div class="field">
                                <div class="field-radiobutton mb-0">
                                    <p-radioButton formControlName="isSubsidyAvailabe" value="0"
                                        id="IsSubsidyAvailabeNo" (onClick)="onSelectSubsidyAvail('0')"></p-radioButton>
                                    <label for="IsSubsidyAvailabeNo">{{'NO' | translate}}</label>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="personalDetailsForm.controls['isSubsidyAvailabe'].invalid && personalDetailsForm.controls['isSubsidyAvailabe'].touched"
                            class="invalid-feedback">
                            <div *ngIf="personalDetailsForm.controls['isSubsidyAvailabe'].errors.required">
                                {{'IS_SUBSIDY_AVAILED_IS_REQUIRED'| translate}}</div>
                        </div>
                    </div>

                    <!-- <div class="field col-12 md:col-3">
                    <label htmlFor="state">{{'IS_SUBSIDY_AVAILED'| translate}}?</label>
                    <div class="formgroup-inline">
                        <div class="field">
                            <div class="field-radiobutton mb-0">
                                <p-radioButton [value]="1" formControlName="isSubsidyAvailabe"
                                    (onChange)="onSelectSubsidyAvail('1')" id="IsSubsidyAvailabeYes"></p-radioButton>
                                <label for="IsSubsidyAvailabeYes">{{'YES'| translate}}</label>
                            </div>
                        </div>
                        <div class="field">
                            <div class="field-radiobutton mb-0">
                                <p-radioButton [value]="0" formControlName="isSubsidyAvailabe"
                                    (onChange)="onSelectSubsidyAvail('0')" id="IsSubsidyAvailabeNo">
                                </p-radioButton>
                                <label for="IsSubsidyAvailabeNo">{{'NO'| translate}}</label>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="personalDetailsForm.controls['isSubsidyAvailabe'].invalid && personalDetailsForm.controls['isSubsidyAvailabe'].touched"
                        class="invalid-feedback">
                        <div *ngIf="personalDetailsForm.controls['isSubsidyAvailabe'].errors.required">
                            {{'IS_SUBSIDY_AVAILED_IS_REQUIRED'| translate}}</div>
                    </div>
                </div> -->

                    <div *ngIf="personalDetailsForm.controls['isSubsidyAvailabe'].value == 1"
                        class="field col-12 md:col-4">
                        <label htmlFor="component">{{'SYETEM_INSTALLED_(DRIP/MINI/PORTABLE)'| translate}}</label>

                        <p-dropdown [options]="componentMasterList" appendTo="body" formControlName="installedSystem"
                            placeholder="{{'SELECT_SYSTEM_INSTALLED'| translate}}" optionLabel="Program_Name"
                            [ngClass]="{ 'g-invalid ng-dirty': personalDetailsForm.controls['installedSystem'].invalid && personalDetailsForm.controls['installedSystem'].touched }"></p-dropdown>

                        <!-- <p-autoComplete formControlName="installedSystem"
                      placeholder="{{'SEARCH'| translate}}" id="Program_Id" [dropdown]="true" [multiple]="false"
                      [suggestions]="filteredComponentMaster" (completeMethod)="filterComponentMaster($event)"
                      field="Program_Name" [ngClass]="{ 'g-invalid ng-dirty': personalDetailsForm.controls['installedSystem'].invalid && personalDetailsForm.controls['installedSystem'].touched }">
                    </p-autoComplete> -->
                        <div *ngIf="personalDetailsForm.controls['installedSystem'].invalid && personalDetailsForm.controls['installedSystem'].touched"
                            class="invalid-feedback">
                            <div *ngIf="personalDetailsForm.controls['installedSystem'].errors.required">
                                {{'SYETEM_INSTALLED_IS_REQUIRED'| translate}}</div>
                        </div>
                    </div>

                    <div *ngIf="personalDetailsForm.controls['isSubsidyAvailabe'].value == 1"
                        class="field col-12 md:col-4">
                        <label htmlFor="yearSubsudy">{{'YEAR'| translate}}</label>
                        <p-dropdown [options]="yearArray" formControlName="yearSubsudy" optionValue="name"
                            optionLabel="name" appendTo="body" placeholder="{{'SELECT_YEAR'| translate}}">
                        </p-dropdown>

                        <div *ngIf="personalDetailsForm.controls['yearSubsudy'].invalid && personalDetailsForm.controls['yearSubsudy'].touched"
                            class="invalid-feedback">
                            <div *ngIf="personalDetailsForm.controls['yearSubsudy'].errors.required">
                                {{'YEAR_IS_REQUIRED'|
                                translate}}</div>
                        </div>
                    </div>

                    <div *ngIf="personalDetailsForm.controls['isSubsidyAvailabe'].value == 1"
                        class="field col-12 md:col-3">
                        <label htmlFor="block">{{'ON_COST_SUBSIDY_BASED' | translate}}</label>
                        <div class="formgroup-inline">
                            <div class="field">
                                <div class="field-radiobutton mb-0">
                                    <p-radioButton formControlName="onCostSubsidyBased" value="1"
                                        id="onCostSubsidyBasedYes" (onClick)="onSelectOnCostS('1')"></p-radioButton>
                                    <label for="onCostSubsidyBasedYes">{{'YES' | translate}}</label>
                                </div>
                            </div>
                            <div class="field">
                                <div class="field-radiobutton mb-0">
                                    <p-radioButton formControlName="onCostSubsidyBased" value="0"
                                        id="onCostSubsidyBasedNo" (onClick)="onSelectOnCostS('0')"></p-radioButton>
                                    <label for="onCostSubsidyBasedNo">{{'NO' | translate}}</label>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="personalDetailsForm.controls['onCostSubsidyBased'].invalid && personalDetailsForm.controls['onCostSubsidyBased'].touched"
                            class="invalid-feedback">
                            <div *ngIf="personalDetailsForm.controls['onCostSubsidyBased'].errors.required">
                                {{'IS_SUBSIDY_AVAILED_IS_REQUIRED'| translate}}</div>
                        </div>
                    </div>

                    <div *ngIf="(personalDetailsForm.controls['isSubsidyAvailabe'].value == 1 && personalDetailsForm.controls['onCostSubsidyBased'].value == 1)"
                        class="field col-12 md:col-4">
                        <label htmlFor="departmentSubsidy">{{'DEPARTMENT'| translate}}</label>
                        <p-dropdown [options]="departmentList" formControlName="departmentSubsidy" optionValue="name"
                            optionLabel="name" appendTo="body" placeholder="{{'SELECT_DEPARTMENT'| translate}}">
                        </p-dropdown>

                        <div *ngIf="personalDetailsForm.controls['departmentSubsidy'].invalid && personalDetailsForm.controls['departmentSubsidy'].touched"
                            class="invalid-feedback">
                            <div *ngIf="personalDetailsForm.controls['departmentSubsidy'].errors.required">
                                {{'DEPARTMANT_IS_REQUIRED'| translate}}</div>
                        </div>
                    </div>



                    <!-- <div class="field col-12 md:col-4">
                    <label htmlFor="fatherName">{{'PPP_PROOF_IMAGE' | translate}}</label>
                    <div class="flex">
                        <p-fileUpload accept=".jpeg,.pdf,.jpg" #farmerPPPFileUpload [customUpload]="true"
                            (uploadHandler)="onUpload($event, 'pppPhotoPath', farmerPPPFileUpload)" name="myfile[]"
                            mode="basic" [maxFileSize]="5000000" chooseLabel="{{'BROWSE' | translate}}" [auto]="true">
                        </p-fileUpload>
                        <p-image *ngIf="personalDetailsForm.controls['pppPhotoPath'].value"
                            [src]="personalDetailsForm.controls['pppPhotoPath'].value" alt="Image" width="60"
                            class="ml-2 p-button-rounded p-button-success" iconPos="left"></p-image>

                    </div>
                    <div *ngIf="personalDetailsForm.controls['pppPhotoPath'].invalid && personalDetailsForm.controls['pppPhotoPath'].touched"
                        class="invalid-feedback">
                        <div *ngIf="personalDetailsForm.controls['pppPhotoPath'].errors.required">
                            {{'PPP_PHOTO_IS_REQUIRED' | translate}}</div>
                    </div>
                </div> -->

                </div>
                <!-- <button pButton pRipple type="button" type="submit" label="{{'SAVE' | translate}}"
                class="p-button-success mr-2 mb-2" style="width: 90px; height: 32px; align-items: center;"></button> -->
                <!-- <div class="field col-12 md:col-4">
                <button class="justify-content-center" pButton type="submit" label="Submit"
                    style="width: 90px; height: 32px;align-items: center;"></button>
            </div> -->
            </form>
        </div>

        <div *ngIf="farmerPastSubsidyList.length > 0" class="p-fluid mt-2 card land-details-card">
            <h5 style="color:rgb(97, 27, 27); font-size: '1.0rem'; font-weight: bold;" class="px-3">
                {{'PAST_SUBSIDY_LIST'| translate}}{{ personalDetailsForm.controls['aadharNo'].value }}</h5>
            <p-table #farmerPastSubsidyTable [value]="farmerPastSubsidyList" [rows]="10" [paginator]="true"
                [globalFilterFields]="[
            'AadharNo',
            'AppId',
            'Area',
            'LandDetail', 
            'System',
            'SubsidyYear', 
            'Department',
            'DiffYear', 
            ]" [rowHover]="true" dataKey="id"
                currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                [showCurrentPageReport]="true" responsiveLayout="scroll">
                <ng-template pTemplate="header">
                    <tr>
                        <!-- <th>{{'AADHAR_NO'| translate}}</th> -->
                        <th>{{'APP_ID'| translate}}</th>
                        <th>{{'AREA'| translate}}</th>
                        <th>{{'LAND_DETAILS'| translate}}</th>
                        <th>{{'SYSTEM'| translate}}</th>
                        <th>{{'SUBSIDY_YEAR'| translate}}</th>
                        <th>{{'DEPARTMENT'| translate}}</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product let-i="rowIndex">
                    <tr>
                        <!-- <td>{{product?.AadharNo}}</td> -->
                        <td>{{product?.AppId}}</td>
                        <td>{{product?.Area}}</td>
                        <td>{{product?.LandDetail}}</td>
                        <td>{{product?.System}}</td>
                        <td>{{product?.SubsidyYear}}</td>
                        <td>{{product?.Department}}</td>
                    </tr>
                </ng-template>
            </p-table>

            <h5 style="color:rgb(249, 55, 55); font-size: '1.2rem'; font-weight: bold; font-family: 'Times New Roman', Times, serif;"
                class="px-3">
                {{'SHOW_INVALID_FARMER_MSG'| translate}} {{ personalDetailsForm.controls['aadharNo'].value }} {{
                'CAN_NOT_PROCEED' | translate}}</h5>

            <div class="d-flex field col-12 justify-content-center align-items-center">
                <button (click)="clearFormData()" pButton pRipple label="{{ 'Clear Form Data' | translate }}"
                    class="p-button-help justify-content-center" style="width: 50vb;"></button>
            </div>
        </div>

        <div *ngIf="farmerPastSubsidyList.length == 0" class="p-fluid mt-2 card land-details-card">
            <h5
                [ngStyle]="{'color': 'rgb(125, 22, 22)', 'font-weight': 'bold', 'display': 'flex', 'justify-content': 'center', 'align-items': 'center'}">
                {{'Land Details' | translate}}</h5>
            <form [formGroup]="farmerLandForm" (ngSubmit)="onSubmitLandDetails()">
                <div class="grid p-fluid mt-3">
                    <div class="field col-12 md:col-4">
                        <span class="p-float-label">
                            <input pInputText inputId="morabbaNumber" type="text" class="form-control"
                                [pKeyFilter]="blockSpace" formControlName="morabbaNumber" autofocus="" tabindex="1"
                                [ngClass]="{ 'ng-invalid ng-dirty': submitted && f.morabbaNumber.errors }" />
                            <div *ngIf="submitted && f.morabbaNumber.errors" class="invalid-feedback">
                                <div *ngIf="f.morabbaNumber.errors.required">{{'MORABBA_NUMBER_IS_REQUIRED'| translate}}
                                </div>
                            </div>
                            <label for="morabbaNumber">{{'MORABBA_NUMBER'| translate}}</label>
                        </span>
                    </div>

                    <div class="field col-12 md:col-4">
                        <span class="p-float-label">
                            <input pInputText inputId="killaNumber" type="text" class="form-control"
                                formControlName="killaNumber" [pKeyFilter]="blockSpace" autofocus="" tabindex="1"
                                [ngClass]="{ 'ng-invalid ng-dirty': submitted && f.killaNumber.errors }" />
                            <div *ngIf="submitted && f.killaNumber.errors" class="invalid-feedback">
                                <div *ngIf="f.killaNumber.errors.required">{{'KILLA_NUMBER_IS_REQUIRED'| translate}}
                                </div>
                            </div>
                            <label for="killaNumber">{{'KILLA_NUMBER'| translate}}</label>
                        </span>
                    </div>

                    <div class="field col-12 md:col-4">
                        <span class="p-float-label">
                            <input readonly pInputText id="totalArea" class="form-control" type="text"
                                formControlName="totalArea" autofocus="" tabindex="1"
                                [ngClass]="{ 'ng-invalid ng-dirty': submitted && f.totalArea.errors }" />
                            <div *ngIf="submitted && f.totalArea.errors" class="invalid-feedback">
                                <div *ngIf="f.totalArea.errors.required">{{'TOTAL_AREA_IS_REQUIRED'| translate}}</div>
                            </div>
                            <label for="totalArea">{{'TOTAL_AREA_IN_ACRE'| translate}}</label>
                        </span>
                    </div>

                    <div class="field col-12 md:col-4">
                        <span class="p-float-label">
                            <input pInputText id="kanals" class="form-control" type="text" formControlName="kanals"
                                autofocus="" tabindex="1"
                                [ngClass]="{ 'ng-invalid ng-dirty': submitted && f.kanals.errors }"
                                (keyup)="onKanalsChange()" maxlength="1" pattern="^([0-1]?[0-8])$" pKeyFilter="int"
                                oninput="if(!this.value.match('^[0-8][0-8]*$'))this.value='';" />
                            <div *ngIf="submitted && f.kanals.errors" class="invalid-feedback">
                                <div *ngIf="f.kanals.errors.required">{{'KANNALS_IS_REQUIRED'| translate}}</div>
                                <div *ngIf="f.kanals.errors.max">{{'KANAL_CANNOT_BE_GREATER'| translate}}.</div>
                            </div>
                            <label for="kanals">{{'AREA_IN_KANALS'| translate}}</label>
                        </span>
                    </div>

                    <div class="field col-12 md:col-4">
                        <span class="p-float-label">
                            <input maxlength="2" pKeyFilter="int" pInputText id="marlas" class="form-control"
                                type="text" formControlName="marlas" autofocus="" tabindex="1"
                                [ngClass]="{ 'ng-invalid ng-dirty': submitted && f.marlas.errors }"
                                (keyup)="onMarlasChange()"
                                oninput="if(!this.value.match('^([0-9]|1[0-9])$'))this.value='';" />
                            <div *ngIf="submitted && f.marlas.errors" class="invalid-feedback">
                                <div *ngIf="f.marlas.errors.required">{{'MARLAS_IS_REQUIRED'| translate}}</div>
                                <div *ngIf="f.marlas.errors.max">{{'MARLAS_SHOULD_NOT_BE_GREATER'| translate}}</div>
                            </div>
                            <label for="marlas">{{'AREA_IN_MARLAS'| translate}}</label>
                        </span>
                    </div>

                    <div class="field col-12 md:col-4">
                        <span class="p-float-label">
                            <p-autoComplete formControlName="villageCode" placeholder="{{'SEARCH'| translate}}" id="dd"
                                [dropdown]="true" [multiple]="false" [suggestions]="filteredVillage" appendTo="body"
                                (completeMethod)="filterVillage($event)" field="Name" value="Code"
                                [ngClass]="{ 'ng-invalid ng-dirty': submitted && f.village.errors }"></p-autoComplete>
                            <!-- <p-autoComplete formControlName="village"
                            placeholder="{{'SEARCH_VILLAGE' | translate}}" appendTo="body" id="dd" [dropdown]="true"
                            [multiple]="false" [suggestions]="filteredVillage" (completeMethod)="filterVillage($event)"
                            field="Name" value="Code"
                            [ngClass]="{ 'ng-invalid ng-dirty': submitted && f.village.errors }"></p-autoComplete> -->

                            <div *ngIf="submitted && f.village.errors" class="invalid-feedback">
                                <div *ngIf="f.village.errors.required">{{'VILLAGE_IS_REQUIRED'| translate}}</div>
                            </div>
                        </span>
                    </div>

                    <div class="field col-12 md:col-4">
                        <span class="p-float-label">
                            <p-multiSelect [showToggleAll]="false" [options]="cropMergeList" formControlName="cropType"
                                [maxSelectedLabels]="4" [selectedItemsLabel]="'{0} items selected'"
                                placeholder="{{'SELECT_CROP_TYPE'| translate}}" [(ngModel)]="selectedNodes1"
                                optionLabel="label" [virtualScroll]="true" [virtualScrollItemSize]="30" appendTo="body"
                                (onChange)="onCropSelect($event)"></p-multiSelect>

                            <div *ngIf="selectedNodes1?.length > 4" class="invalid-feedback">
                                <div>{{'MAXIMUM_4_CROP_IS_ALLOWED_YOU_SELECTED'| translate}} {{ selectedNodes1.length }}
                                </div>
                            </div>
                            <div *ngIf="submitted && f.cropType.errors" class="invalid-feedback">
                                <div *ngIf="f.cropType.errors.required">{{'CROP_TYPE_IS_REQUIRED'| translate}}</div>
                            </div>
                        </span>
                    </div>

                    <div class="field col-12 md:col-6">
                        <!-- <div class="flex"> -->
                        <label for="name" class="ml-2">{{'UPLOAD_LAND_DOCUMENT' | translate}}</label>
                        <p-fileUpload accept=".jpeg,.pdf,.jpg" [customUpload]="true" #farmerLandLocUpload
                            (uploadHandler)="onLandUpload($event, 'landdoc_Path', farmerLandLocUpload)" name="myfile[]"
                            [maxFileSize]="5000000" [multiple]="false" chooseLabel="{{'CHOOSE'| translate}}"
                            [auto]="false" [showCancelButton]="false">
                            <!-- <ng-template pTemplate="content">
                            <ul *ngIf="uploadedlandFiles.length">
                                <li *ngFor="let file of uploadedlandFiles">
                                    <p-image *ngIf="f.landdoc_Path.value" [src]="f.landdoc_Path.value" alt="Image"
                                        width="60" class="ml-2" iconPos="left"></p-image>
                                    {{ file.name }} - {{ file.size }} bytes
                                </li>
                            </ul>
                        </ng-template> -->
                        </p-fileUpload>
                        <!-- <p-image *ngIf="f.landdoc_Path.value" [src]="f.landdoc_Path.value" alt="Image" width="60"
                            class="ml-2" iconPos="left"></p-image> -->
                        <!-- </div> -->
                        <div *ngIf="submitted && f.landdoc_Path.errors" class="invalid-feedback">
                            <!-- <div *ngIf="f.landdoc_Path.errors.required">{{'LAND_DOCUMENT_IS_REQUIRED'| translate}}</div> -->
                            <div *ngIf="f.landdoc_Path.errors.required">{{'CHOOSE_AND_UPLOAD_LAND_DOCUMENT'| translate}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="button-container">
                    <button pButton pRipple type="submit" [disabled]="farmerLandForm.invalid" icon="pi pi-plus"
                        label="{{'Add' | translate}}" class="p-button-secondary mr-2 mb-2"
                        style="width: 90px; height: 32px; align-items: center;">
                    </button>
                </div>
            </form>
        </div>

        <div class="card dashboardTable" *ngIf="addedLandData.length > 0">

            <!-- <p-table #landDetails [value]="addedLandData" [rows]="10" [paginator]="true"
            [globalFilterFields]="['Land_ID','Total_Area','Morabba_No','Killa_No','VillageName']" [rowHover]="true"
            currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
            [showCurrentPageReport]="true" responsiveLayout="scroll">
            <ng-template pTemplate="header">
                <tr>
                    <th>{{'MORABBA_NUMBER'| translate}}</th>
                    <th>{{'KILLA_NUMBER'| translate}}</th>
                    <th>{{'Kanals'| translate}}</th>
                    <th>{{'TOTAL_AREA'| translate}}</th>
                    <th>{{'CROP'| translate}}</th>
                    <th>{{'LAND_DOC'| translate}}</th>
                    <th>{{'ACTION'| translate}}</th>
                    <th>{{'Expend'| translate}}</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product let-expanded="expanded" let-i="rowIndex">
              <tr>
                    <td>{{product?.morabbaNumber}}</td>
                    <td>{{product?.killaNumber}}</td>
                    <td>{{product?.kanals}}</td>
                    <td>{{product?.totalArea}}</td>
                    <td>{{product?.cropValue}}</td>
                    <td>
                        <a style="cursor: pointer" icon="pi pi-eye" [href]="product?.landdoc_Path" target="_blank">
                            <button pButton type="button"
                                class="p-button-rounded p-button-accent p-button-secondary p-button-rounded"
                                pTooltip="{{ 'VIEW' | translate }}" icon="pi pi-eye"></button>
                        </a>
                    </td>
                    <td>
                        <div>
                            <button pButton pRipple icon="pi pi-trash"
                                class="p-button-rounded p-button-accent p-button-danger p-button-rounded"
                                (click)="deleteLand(product, i)"></button>
                        </div>
                    </td>
                    <td>
                        <button pButton type="button" (click)="toggleRow(product)" icon="pi" 
                            [icon]="expandedRows[product.killaNumber] ? 'pi-chevron-up' : 'pi-chevron-down'" class="p-button-text"></button>
                    </td>
              </tr>
              <tr *ngIf="expandedRows[product.killaNumber]">
                <td colspan="3">
                    <p-table [value]="product.cropType" [rowHover]="true" responsiveLayout="scroll">
                        <ng-template pTemplate="header">
                        <tr>
                            <th>{{'CROP'| translate}}</th>
                            <th>{{'CROP_TYPE'| translate}}</th>
                        </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-detail>
                        <tr>
                            <td>{{detail?.parentLabel}}</td>
                            <td>{{detail?.label}}</td>
                        </tr>
                        </ng-template>
                    </p-table>
                </td>
              </tr>
            </ng-template>
        </p-table> -->

            <p-table #landDetails [value]="addedLandData" [rows]="10" [paginator]="false"
                [globalFilterFields]="['Land_ID','Total_Area','Morabba_No','Killa_No','VillageName']" [rowHover]="true"
                dataKey="id"
                currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                [showCurrentPageReport]="true" responsiveLayout="scroll">
                <ng-template pTemplate="header">
                    <tr>
                        <th>{{'MORABBA_NUMBER'| translate}}</th>
                        <th>{{'KILLA_NUMBER'| translate}}</th>
                        <th>{{'Kanals'| translate}}</th>
                        <th>{{'TOTAL_AREA'| translate}}</th>
                        <th>{{'CROP'| translate}}</th>
                        <th>{{'VILLAGE'| translate}}</th>
                        <th>{{'LAND_DOC'| translate}}</th>
                        <th>{{'ACTION'| translate}}</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product let-i="rowIndex">
                    <tr>
                        <td>{{product?.morabbaNumber}}</td>
                        <td>{{product?.killaNumber}}</td>
                        <td>{{product?.kanals}}</td>
                        <td>{{product?.totalArea}}</td>
                        <td>{{product?.cropValue}}</td>
                        <td>{{product?.village}}</td>
                        <td>
                            <a style="cursor: pointer" icon="pi pi-eye" [href]="product?.landdoc_Path" target="_blank">
                                <button pButton type="button"
                                    class="p-button-rounded p-button-accent p-button-secondary p-button-rounded"
                                    pTooltip="{{ 'VIEW' | translate }}" icon="pi pi-eye"></button>
                            </a>
                        </td>
                        <td>
                            <div>
                                <button pButton pRipple icon="pi pi-trash"
                                    class="p-button-rounded p-button-accent p-button-danger p-button-rounded"
                                    (click)="deleteLand(product, i)"></button>
                            </div>
                        </td>

                    </tr>
                </ng-template>
            </p-table>
        </div>

        <!-- <div class="p-table-wrapper">
        <p-table *ngIf="addedPersonalData.length" [value]="addedPersonalData">
            <ng-template pTemplate="header">
                <tr>
                    <th>Aadhar No</th>
                    <th>Name</th>
                    <th>Father Name</th>
                    <th>Mother Name</th>
                    <th>Gender</th>
                    <th>DOB</th>
                    <th>PPP Id</th>
                    <th>Mobile</th>
                    <th>Caste Code</th>
                    <th>Address</th>
                    <th>Pin Code</th>
                    <th>Email Id</th>
                    <th>Village Code</th>
                    <th>MFMB No</th>
                    <th>Delete</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data let-i="rowIndex">
                <tr>
                    <td>{{data.aadharNo}}</td>
                    <td>{{data.name}}</td>
                    <td>{{data.fatherName}}</td>
                    <td>{{data.motherName}}</td>
                    <td>{{data.gender}}</td>
                    <td>{{data.dob | date: 'dd/MM/yyyy'}}</td>
                    <td>{{data.pppId}}</td>
                    <td>{{data.mobile}}</td>
                    <td>{{data.casteCode}}</td>
                    <td>{{data.address}}</td>
                    <td>{{data.pinCode}}</td>
                    <td>{{data.emailId}}</td>
                    <td>{{data.villageCode}}</td>
                    <td>{{data.mfmbNo}}</td>
                    <td>
                        <button pButton icon="pi pi-trash" (click)="deleteRow(i)"></button>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div> -->

        <div *ngIf="addedLandData.length > 0" class="button-container-submit">
            <button pButton pRipple (click)="onAddFarmerForm()" label="{{'SUBMIT_FARMER_DETAILS' | translate}}"
                class="p-button-success mr-2 mb-2" style="align-items: center;">
            </button>
        </div>
    </div>
</div>
<!-- </p-panel> -->

<!-- <p-panel header="Add Estimation" [toggleable]="true" [toggleable]="true"> -->
<div class="farmer-data card">
    <p [style]="{'color': 'rgb(168, 32, 32)', 'font-weight': 'bold', 'font-size': '1.0rem'}">{{ 'Add Estimation' |
        translate }}</p>
    <div class="card">
        <div class="p-fluid p-formgrid grid added-farmer-data">
            <div class="field col-12 md:col-3">
                <label htmlFor="selectOutletMaster">{{'SELECT_OUTLET_RD'| translate}}</label>
                <div class="grid-item">
                    <p-dropdown [disabled]="hideGetDataButton" [options]="contractorOutletList"
                        [(ngModel)]="selectedOutletToGetData" (onChange)="onSelectOutletToGetData()" appendTo="body"
                        placeholder="{{ 'SELECT_OUTLET_RD'| translate }}" optionLabel="Outlets"></p-dropdown>
                </div>
            </div>

            <div *ngIf="selectedOutletToGetData" class="field col-12 md:col-3">
                <label htmlFor="selectBenefitedArea">{{'BENEFITED_AREA_(IN_ACRE)'| translate}}</label>
                <div class="grid-item">
                    <input type="text" class="readonly" readonly pInputText [(ngModel)]="selectedBenefitedAreaToGetData"
                        variant="filled" />
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label htmlFor="selectOutletMaster">{{'AGREEMENT_NO'| translate}}</label>
                <div class="grid-item">
                    <!-- <input [disabled]="hideGetDataButton" [(ngModel)]="agreementNoToGetData" pInputText type="text" /> -->
                    <p-dropdown [disabled]="hideGetDataButton" [options]="agreementNoList"
                        [(ngModel)]="agreementNoToGetData" appendTo="body" (onChange)="onClickAgreementNo()"
                        placeholder="{{ 'SELECT_AGREEMENT_NO'| translate }}" optionLabel="AgreementNo"></p-dropdown>
                </div>
            </div>

            <div *ngIf="chunkList.length > 0" class="field col-12 md:col-3">
                <label htmlFor="selectOutletMaster">{{'CHUNK'| translate}}</label>
                <div class="grid-item">
                    <p-dropdown [disabled]="hideGetDataButton" [options]="chunkList" [(ngModel)]="chunkIdToGetData" appendTo="body" 
                        placeholder="{{ 'SELECT_CHUNK'| translate }}" optionLabel="combineData"></p-dropdown>
                </div>
            </div>

            <div class="field col-12 md:col-3">
                <label *ngIf="chunkList.length == 0"></label>
                <div *ngIf="!hideGetDataButton" class="d-flex justify-content-center align-items-center vh-100 mt-2">
                    <button (click)="onClickGetFarmerData()" pButton pRipple
                        label="{{ 'Get Farmer Details' | translate }}" class="p-button-success"></button>
                </div>

                <div *ngIf="hideGetDataButton" class="d-flex justify-content-center align-items-center vh-100 mt-2">
                    <button (click)="clearGetData()" pButton pRipple label="{{ 'Clear Details' | translate }}"
                        class="p-button-help"></button>
                </div>
            </div>
        </div>

    </div>

    <div class="dashboardTable" *ngIf="addedFarmerData.length > 0">
        <p class="pt-2 mx-2" [style]="{'color': 'rgb(168, 32, 32)', 'font-weight': 'bold', 'font-size': '1.0rem'}">{{ 'Added Farmer
            Details' | translate }} {{ 'of ' }}{{ this.selectedOutletToGetData?.Outlets }} {{ ' & Agreement No:'}} {{
            agreementNoToGetData?.AgreementNo }}</p>
        <p-table #epcDataTable [value]="addedFarmerData" [rows]="10" [paginator]="true" [globalFilterFields]="[
            'APP_ID',
            'Applicant_type',
            'Name',
            'Father_name',
            'Aadhar_No',
            'Mobile',
            'PPP_ID',
            'MFMBNo'
            ]" [rowHover]="true" dataKey="Aadhar_No" (onRowSelect)="onRowSelect($event)" (onRowUnselect)="onRowUnselect($event)" 
            [(selection)]="selectedFarmerForEstimation"
            currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
            [showCurrentPageReport]="true" responsiveLayout="scroll">
            <ng-template pTemplate="caption">
                <div class="flex align-items-center justify-content-end">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text"
                            (input)="epcDataTable.filterGlobal($any($event.target).value, 'contains')"
                            placeholder="{{'SEARCH'| translate}}" />
                    </span>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th></th>
                    <th>{{'S.No'| translate}}</th>
                    <th>{{'APP_ID'| translate}}</th>
                    <!-- <th>{{'APPLICANT_TYPE'| translate}}</th> -->
                    <th>{{'FARMER_NAME'| translate}}</th>
                    <th>{{'FATHERS_NAME'| translate}}</th>
                    <th>{{'AADHAR_NO'| translate}}</th>
                    <th>{{'MOBILE_NO'| translate}}</th>
                    <th>{{'PPP_ID'| translate}}</th>
                    <th>{{'MFMB_NO'| translate}}</th>
                    <th>{{'ACTION'| translate}}</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product let-expanded="expanded" let-i="rowIndex">
                <tr (click)="toggleRow(product)">
                    <td>
                        <p-tableRadioButton [value]="product"></p-tableRadioButton>
                    </td>
                    <td>{{ i + 1 }}</td>
                    <td>{{product?.APP_ID}}</td>
                    <!-- <td>{{product?.Applicant_type}}</td> -->
                    <td>{{product?.Name}}</td>
                    <td>{{product?.Father_name}}</td>
                    <td>{{product?.Aadhar_No}}</td>
                    <td>{{product?.Mobile}}</td>
                    <td>{{product?.PPP_ID}}</td>
                    <td>{{product?.MFMBNo}}</td>
                    <td>
                        <button pButton pRipple type="button" pTooltip="Edit-Estimation"
                            (click)="editPersonalDetails(product)" icon="pi pi-pencil"
                            class="p-button-rounded p-button-text"></button>
                        <button pButton pRipple type="button" pTooltip="Delete" icon="pi pi-times"
                            class="p-button-rounded p-button-text p-button-danger"
                            (click)="deletePersonalDetails(product)"></button>
                    </td>
                </tr>
                <!-- <tr *ngIf="expandedRows[product.landDetails]">
                    <td colspan="12">
                        <p-table [value]="product.landDetails" [rowHover]="true" responsiveLayout="scroll">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>{{'MORABBA_NUMBER'| translate}}</th>
                                    <th>{{'KILLA_NUMBER'| translate}}</th>
                                    <th>{{'Kanals'| translate}}</th>
                                    <th>{{'TOTAL_AREA'| translate}}</th>
                                    <th>{{'CROP'| translate}}</th>
                                    <th>{{'LAND_DOC'| translate}}</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-detail>
                                <tr>
                                    <td>{{detail?.morabbaNumber}}</td>
                                    <td>{{detail?.killaNumber}}</td>
                                    <td>{{detail?.kanals}}</td>
                                    <td>{{detail?.totalArea}}</td>
                                    <td>{{detail?.cropValue}}</td>
                                    <td>
                                        <a style="cursor: pointer" icon="pi pi-eye" [href]="detail?.landdoc_Path" target="_blank">
                                            <button pButton type="button"
                                                class="p-button-rounded p-button-accent p-button-secondary p-button-rounded"
                                                pTooltip="{{ 'VIEW' | translate }}" icon="pi pi-eye"></button>
                                        </a>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </td>
                </tr> -->
            </ng-template>
            <ng-template pTemplate="summary">
                <div class="summary-container">
                    <p>
                        Outlet Amount Per Hec is Rs. {{ addedFarmerData[0].OutletAmountPerHA }}/-.
                    </p>
                </div>
            </ng-template>
        </p-table>

        <!-- <div class="card program-area-count p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
            <h5 style="color:rgb(97, 27, 27); font-size: '1.0rem'; font-weight: bold;" class="px-3">
                {{'Programme wise total land area.'| translate}}</h5>

            <div class="field md:col-4 col-12">
                <label>{{'Portable Sprinkler'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">
                    {{totalPortableAreaCount}} acres.</label></label>
            </div>
    
            <div class="field md:col-4 col-12">
                <label>{{'Mini Sprinkler'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">
                    {{ totalMiniAreaCount }} acres.</label></label>
            </div>
            <div class="field md:col-4 col-12">
                <label>{{'Drip'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">
                    {{ totalDripAreaCount }} acres.</label></label>
            </div>
        </div> -->
        <div class="dashboardProgWiseTable" *ngIf="selectedFarmerForEstimation.length > 0 && selectedFarmerForEstimation[0].OutletAmount != null">
            <p-table #table1 class="mainTable1" [value]="programWiseData" [rows]="3" [paginator]="false"
                [rowHover]="true" responsiveLayout="scroll" [showCurrentPageReport]="false">
                <ng-template pTemplate="caption">
                    <div class="flex align-items-center justify-content-between">
                        <h5 style="color:rgb(97, 27, 27); font-size: '1.0rem'; font-weight: bold;" class="px-3"><b>{{
                                ''| translate}}</b></h5>
                        <!-- <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="table1.filterGlobal($any($event.target).value, 'contains')"
                      placeholder="{{'SEARCH'| translate}}" />
                  </span> -->
                    </div>
                </ng-template>

                <ng-template pTemplate="header">
                    <tr>
                        <th>{{'PROGRAMME_NAME'| translate}}</th>
                        <th>{{'TOTAL_BENEFITED_AREA'| translate}}</th>
                        <th>{{'TOTAL_BENEFICIARIES'| translate}}</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product let-columns="columns">
                    <tr>
                        <td>{{product?.progName}}</td>
                        <td>{{product?.totaAreaCount}}</td>
                        <td>{{product?.totalCount}}</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>

    </div>

    <div *ngIf="selectedFarmerForEstimation.length > 0 && selectedFarmerForEstimation[0].OutletAmount != null">
        <div class="estimation-details">
            <form [formGroup]="estimationDetailsForm">
                <p class="pt-3 mx-2" [style]="{'color': 'rgb(168, 32, 32)', 'font-weight': 'bold', 'font-size': '1.0rem'}">{{ 'Estimation
                    Details' | translate }}</p>
                <div class="p-fluid p-formgrid grid mx-2">
                    <div class="field col-12 md:col-3">
                        <label htmlFor="selectProgram">{{'PROGRAMME_NAME'| translate}}</label>
                        <div class="grid-item">
                            <p-dropdown [options]="componentMasterListForEstimation" formControlName="programmeName"
                                optionLabel="Program_Name" (onChange)="onSelectProgramme()"
                                placeholder="{{'SELECT_A_PROGRAMME'| translate}}" appendTo="body">
                            </p-dropdown>
                        </div>
                        <div *ngIf="estimationDetailsForm.controls['programmeName'].invalid && estimationDetailsForm.controls['programmeName'].touched"
                            class="p-error">
                            {{'PROGRAMME_NAME_IS_REQUIRED' | translate}}
                        </div>
                    </div>

                    <!-- <div class="field col-12 md:col-4">
                        <label htmlFor="vendor">{{'VENDOR'| translate}} </label>
                        <div class="grid-item">
                            <p-autoComplete placeholder="{{ 'SEARCH_VENDOR' | translate }}" id="dd" [dropdown]="true" [multiple]="false" optionLabel="Name" optionValue="Vendor_Code"
                                formControlName="vendor" [suggestions]="filteredmiVendorList" (completeMethod)="filterMIVendor($event)" appendTo="body"
                                field="Name" (onSelect)="onVendorSelect($event)"></p-autoComplete>
                        </div>
                        <div *ngIf="estimationDetailsForm.controls['vendor'].invalid && estimationDetailsForm.controls['vendor'].touched"
                            class="p-error">
                            {{'VENDOR_IS_REQUIRED' | translate}}
                        </div>
                    </div> -->

                    <div class="field col-12 md:col-3">
                        <label htmlFor="selectCategory">{{'SELECT_CATEGORY'| translate}}</label>
                        <div class="grid-item">
                            <p-dropdown [options]="category" formControlName="category" (onChange)="onSelectCategory()"
                                placeholder="{{'SELECT_A_CATEGORY'| translate}}" optionLabel="categoryName"
                                appendTo="body"></p-dropdown>
                        </div>
                        <div *ngIf="estimationDetailsForm.controls['category'].invalid && estimationDetailsForm.controls['category'].touched"
                            class="p-error">
                            {{'CATEGORY_IS_REQUIRED' | translate}}
                        </div>
                    </div>

                    <div class="field col-12 md:col-3">
                        <label htmlFor="selectComponent">{{'SELECT_COMPONENT'| translate}}</label>
                        <div class="grid-item">
                            <p-dropdown [options]="component" formControlName="component"
                                (onChange)="onSelectComponent()" placeholder="{{'SELECT_A_COMPONENT'| translate}}"
                                optionLabel="componentName" appendTo="body"></p-dropdown>
                        </div>
                        <div *ngIf="estimationDetailsForm.controls['component'].invalid && estimationDetailsForm.controls['component'].touched"
                            class="p-error">
                            {{'COMPONENT_IS_REQUIRED' | translate}}
                        </div>
                    </div>

                    <div class="field col-12 md:col-3">
                        <label htmlFor="selectedSizePrice">{{'SELECT_SIZE'| translate}}</label>
                        <div class="grid-item">
                            <p-dropdown [options]="sizePrice" formControlName="sizePrice"
                                (onChange)="onSelectSizePrice()" placeholder="{{'SELECT_SIZE'| translate}}"
                                optionLabel="sizeOnly" appendTo="body"></p-dropdown>
                        </div>
                        <div *ngIf="estimationDetailsForm.controls['sizePrice'].invalid && estimationDetailsForm.controls['sizePrice'].touched"
                            class="p-error">
                            {{'SIZE_PRICE_IS_REQUIRED' | translate}}
                        </div>
                    </div>

                    <div class="field col-12 md:col-3">
                        <label htmlFor="enterQuantity">{{'ENTER_QUANTITY'| translate}}</label>
                        <div class="grid-item">
                            <input type="number" min="1" step="1" formControlName="enteredQuantity"
                                onkeypress="return event.charCode >= 48 && event.charCode <= 57" title="Numbers only"
                                pInputText required
                                [ngClass]="{ 'ng-invalid ng-dirty': estimationDetailsForm.controls['enteredQuantity'].touched && estimationDetailsForm.controls['enteredQuantity'].value < 1 }">
                        </div>
                        <div *ngIf="estimationDetailsForm.controls['enteredQuantity'].invalid && estimationDetailsForm.controls['enteredQuantity'].touched"
                            class="p-error">
                            <div *ngIf="estimationDetailsForm.controls['enteredQuantity'].errors.required">
                                {{'QUANTITY_IS_REQUIRED'
                                | translate}}</div>
                            <div *ngIf="estimationDetailsForm.controls['enteredQuantity'].errors.min">
                                {{'NOTE_ON_INVALID_QUANTITY' |
                                translate}}</div>
                        </div>
                    </div>

                    <div class="field col-12 md:col-3">
                        <label htmlFor="perUnitCost">{{'PER_UNIT_COST'| translate}}</label>
                        <div class="grid-item">
                            <input type="number" min="0.01" step="0.01" formControlName="perUnitCost" pInputText required
                                [ngClass]="{ 'ng-invalid ng-dirty': estimationDetailsForm.controls['perUnitCost'].touched && estimationDetailsForm.controls['perUnitCost'].value < 0.01 }"
                                title="Numbers only, including decimals">
                        </div>
                        <div *ngIf="estimationDetailsForm.controls['perUnitCost'].invalid && estimationDetailsForm.controls['perUnitCost'].touched"
                            class="p-error">
                            <div *ngIf="estimationDetailsForm.controls['perUnitCost'].errors.required">
                                {{'PER_UNIT_COST_IS_REQUIRED'
                                | translate}}</div>
                            <div *ngIf="estimationDetailsForm.controls['perUnitCost'].errors.min">
                                {{'NOTE_ON_INVALID_QUANTITY' |
                                translate}}</div>
                        </div>
                    </div>

                    <!-- <div class="field col-12 md:col-3">
                        <label htmlFor="conPrice">{{'PRICE'| translate}}</label>
                        <div class="grid-item">
                            <input type="number" min="1" step="1" formControlName="price"
                                onkeypress="return event.charCode >= 48 && event.charCode <= 57" title="Numbers only"
                                pInputText required
                                [ngClass]="{ 'ng-invalid ng-dirty': estimationDetailsForm.controls['price'].touched && estimationDetailsForm.controls['price'].value < 1 }">
                            <input class="readonly" readonly type="number" formControlName="conPrice" pInputText required
                                [ngClass]="{ 'ng-invalid ng-dirty': estimationDetailsForm.controls['conPrice'].touched && estimationDetailsForm.controls['conPrice'].value == 0 }">
                        </div>
                        <div *ngIf="estimationDetailsForm.controls['conPrice'].invalid && estimationDetailsForm.controls['conPrice'].touched"
                            class="p-error">
                            <div *ngIf="estimationDetailsForm.controls['conPrice'].errors.required">
                                {{'PRICE_IS_REQUIRED'
                                | translate}}</div>
                            <div *ngIf="estimationDetailsForm.controls['conPrice'].errors.min">
                                {{'NOTE_ON_INVALID_QUANTITY' |
                                translate}}</div>
                        </div>
                    </div> -->

                    <div class="field col-12 md:col-3">
                        <label htmlFor="enterQuantity">{{'COVERED_AREA(IN_ACRE)'| translate}}</label>
                        <div class="grid-item">
                            <!-- <input type="number" min="0.000001" formControlName="coveredArea"
                                onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || (event.charCode == 46 && !this.value.includes('.'))"
                                pInputText required
                                [ngClass]="{ 'ng-invalid ng-dirty': estimationDetailsForm.controls['coveredArea'].touched && estimationDetailsForm.controls['enteredQuantity'].value == 0 }"> -->
                                <input class="readonly" readonly type="number" formControlName="coveredArea" pInputText required
                                    [ngClass]="{ 'ng-invalid ng-dirty': estimationDetailsForm.controls['coveredArea'].touched && estimationDetailsForm.controls['enteredQuantity'].value == 0 }">
                        </div>
                        <div *ngIf="estimationDetailsForm.controls['coveredArea'].invalid && estimationDetailsForm.controls['coveredArea'].touched"
                            class="p-error">
                            <div *ngIf="estimationDetailsForm.controls['coveredArea'].errors.required">
                                {{'COVERED_AREA_IS_REQUIRED'
                                | translate}}</div>
                            <div *ngIf="estimationDetailsForm.controls['coveredArea'].errors.min">
                                {{'Covered Area Must be Greater than 0' |
                                translate}}</div>
                        </div>
                    </div>

                    <div class="field col-12 md:col-3">
                        <label></label>
                        <div class="grid-item mt-1">
                            <button pButton pRipple type="submit" icon="pi pi-plus" label="{{'ADD'| translate}}"
                                (click)="addEstimateData()" class="p-button-secondary mt-2 ml-5"
                                style="width: 90px; height: 32px; align-items: center;">
                            </button>
                        </div>
                    </div>
                </div>
            </form>

            <div *ngIf="showErrMsgOfInvArea">
                <h5 style="color:red; font-size: '1.0rem'; font-weight: bold;" class="px-3"><b>{{ invAreaMsg }}</b></h5>
            </div>
        </div>

        <div *ngIf="estimationTableData.length > 0" class="card dashboardTable" style="margin: 5px;">
            <p-table [value]="estimationTableData" [rows]="10" [paginator]="false"
                [globalFilterFields]="['programmeName', 'vendorName', 'CatName', 'ComponentName', 'Size', 'Price', 'Quantity', 'Amount']"
                responsiveLayout="scroll" [rowHover]="true" [showCurrentPageReport]="true">
                <ng-template pTemplate="header">
                    <tr>
                        <th>{{'S_NO'| translate}}</th>
                        <th>{{'PROGRAMME_NAME'| translate}}</th>
                        <!-- <th>{{'VENDOR_NAME'| translate}}</th> -->
                        <th>{{'CATEGORY_NAME'| translate}}</th>
                        <th>{{'COMPONENT_NAME'| translate}}</th>
                        <th>{{'SIZE'| translate}}</th>
                        <!-- <th>{{'PRICE'| translate}}</th> -->
                        <th>{{'QUANTITY'| translate}}</th>
                        <th>{{'PER_UNIT_COST'| translate}}</th>
                        <th>{{'TOTAL_AMOUNT'| translate}}</th>
                        <!-- <th>{{'COVERED_AREA'| translate}}</th> -->
                        <!-- <th>{{'AMOUNT'| translate}}</th> -->
                        <th>{{'ACTION'| translate}}
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
                    <tr>
                        <td>{{rowIndex + 1}}</td>
                        <td>{{product.programmeName}}</td>
                        <!-- <td>{{product.vendorName}}</td> -->
                        <td>{{product.CatName}}</td>
                        <td>{{product.ComponentName}}</td>
                        <td>{{product.Size}}</td>
                        <!-- <td>{{'RS.'| translate}} {{product.Price | number : '1.2-2'}}</td> -->
                        <td>{{product.Quantity}}</td>
                        <td>{{product.PerUnitCost}}</td>
                        <td>{{product.ConPrice | currency:'INR'}}</td>
                        <!-- <td>{{product.CoveredArea}}</td> -->
                        <!-- <td>{{'RS.'| translate}} {{product.Amount | number : '1.2-2'}}</td> -->
                        <td><button pButton pRipple type="button" icon="pi pi-times"
                                (click)="onDeleteEstimationRow(product, rowIndex)"
                                class="p-button-rounded p-button-text p-button-danger"></button></td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="footer">
                    <tr class="grand-total-row">
                      <td colspan="7" style="text-align: right; font-weight: bold;">Grand Total:</td>
                      <!-- <td>{{ grandTotalQuantity }}</td> -->
                      <td>{{ grandTotalCost  | currency:'INR' }}</td>
                    </tr>
                </ng-template>
            </p-table>

            <div class="p-fluid p-formgrid grid mt-2">
                <div class="field col-12 md:col-12 consent-checkbox">
                    <div class="field col-12 md:col-12">
                        <span>
                            <p-checkbox name="group1" value="true" [(ngModel)]="consentCheckBox" id="ch"></p-checkbox>
                                <!-- [ngClass]="{ 'ng-invalid ng-dirty': (isSubmitted || f.checkBoxRec.touched) && f.checkBoxRec.errors }"></p-checkbox> -->
                            <label htmlFor="consent" class="ml-2">{{'To run the system successfully for the area' }} {{ selectedFarmerForEstimation[0].TotalArea }}
                                {{ '(acre), the quantities designed & estimated above are as per PDMC guidelines and component wise rates submitted are proportionate to approved rates of authorized vendor & contract price.'}}</label>
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="estimationTableData.length > 0" class="button-container-submit">
            <button pButton pRipple (click)="onSubmitForm()" label="{{'SUBMIT' | translate}}" class="p-button-success"
                style="width: 100px; height: 32px; align-items: center;">
            </button>
        </div>
    </div>
</div>
<!-- </p-panel> -->


<p-dialog header="Update Personal Details" [baseZIndex]="-1000" [(visible)]="showUpdatePersonalDialog" [modal]="true" [style]="{width: '85%',height:'100%'}"
    [maximizable]="true" [draggable]="false" [resizable]="false" (onHide)="onCloseUpdatePerDialog()">
    <!-- <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
        <div class="field md:col-4 col-12">
            <label>{{'APP_ID'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{
                applicationNo}}</label></label>
        </div>

        <div class="field md:col-4 col-12">
            <label>{{'FARMER_NAME'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{ programmeFarmerName |
                    uppercase}}</label></label>
        </div>
        <div class="field md:col-4 col-12">
            <label>{{'PROG_NAME'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{ programName |
                    uppercase}}</label></label>
        </div>
    </div> -->

    <!-- <div class="card field-content" style="margin-bottom: 5px;"> -->

        <div class="p-fluid card personal-details-update-card">
            <form [formGroup]="updatePersonalDetailsForm" (ngSubmit)="onUpdatePersonalDetails()">
                <h5
                    [ngStyle]="{'color': 'rgb(125, 22, 22)', 'font-weight': 'bold', 'display': 'flex', 'justify-content': 'center', 'align-items': 'center'}">
                    {{ 'App Id' | translate}} {{ ' ' }} ( {{ selectedApplicationNo }} )</h5>

                <div class="p-fluid p-formgrid grid justify-content-left personal-details-form">
                    <div class="field col-12 md:col-4">
                        <label for="name">{{'FARMER_NAME' | translate}}</label>
                        <input id="name" type="text" pInputText formControlName="name">
                        <div *ngIf="updatePersonalDetailsForm.controls['name'].invalid && updatePersonalDetailsForm.controls['name'].touched"
                            class="p-error">
                            {{'FARMER_NAME_IS_REQUIRED' | translate}}
                        </div>
                    </div>

                    <div class="field col-12 md:col-4">
                        <label for="fatherName">{{'FATHERS_NAME' | translate}}</label>
                        <input id="fatherName" type="text" pInputText formControlName="fatherName">
                        <div *ngIf="updatePersonalDetailsForm.controls['fatherName'].invalid && updatePersonalDetailsForm.controls['fatherName'].touched"
                            class="p-error">
                            {{'FATHERS_NAME_IS_REQUIRED' | translate}}
                        </div>
                    </div>

                    <div class="field col-12 md:col-4">
                        <label htmlFor="mobileNo">{{'MOBILE_NO' | translate}}</label>
                        <input maxlength="10" pattern="^[0-9]{10}$" pKeyFilter="int" formControlName="mobileNo"
                            pInputText id="mobileNo" type="text"
                            [ngClass]="{ 'ng-invalid ng-dirty': updatePersonalDetailsForm.controls['mobileNo'].invalid && updatePersonalDetailsForm.controls['mobileNo'].touched }" />

                        <div *ngIf="updatePersonalDetailsForm.controls['mobileNo'].invalid && updatePersonalDetailsForm.controls['mobileNo'].touched"
                            class="p-error">
                            <div *ngIf="updatePersonalDetailsForm.controls['mobileNo'].errors.required">
                                {{'MOBILE_NO_IS_REQUIRED'
                                | translate}}</div>

                            <div *ngIf="updatePersonalDetailsForm.controls['mobileNo'].errors.minlength">
                                {{'MOBILE_NO_SHOULD_BE_OF_10_DIGITS' |
                                translate}}</div>
                            <div *ngIf="updatePersonalDetailsForm.controls['mobileNo'].errors.maxlength">
                                {{'MOBILE_NO_SHOULD_BE_OF_10_DIGITS' |
                                translate}}</div>
                            <div *ngIf="updatePersonalDetailsForm.controls['mobileNo'].errors.pattern">
                                {{'MBILE_NO_SHOULD_CONTAIN'
                                | translate}}</div>
                        </div>
                    </div>

                    <div class="field col-12 md:col-4">
                        <label htmlFor="mfmbNo">{{'MFMB_NO' | translate}}</label>
                        <input maxlength="8" pattern="^[0-9]{8}$" pKeyFilter="int" formControlName="mfmbNo" pInputText
                            id="block" type="text"
                            [ngClass]="{ 'ng-invalid ng-dirty': updatePersonalDetailsForm.controls['mfmbNo'].invalid && updatePersonalDetailsForm.controls['mfmbNo'].touched }" />
                        <div *ngIf="updatePersonalDetailsForm.controls['mfmbNo'].invalid && updatePersonalDetailsForm.controls['mfmbNo'].touched"
                            class="invalid-feedback">
                            <div *ngIf="updatePersonalDetailsForm.controls['mfmbNo'].errors.required">{{'MFMB_NO_REQUIRED' |
                                translate}}</div>
                            <div *ngIf="updatePersonalDetailsForm.controls['mfmbNo'].errors.minlength">
                                {{'MFMB_NO_REQUIRED_NO_IS_SHOULD_BE_OF_12_DIGITS' |
                                translate}}</div>
                            <div *ngIf="updatePersonalDetailsForm.controls['mfmbNo'].errors.maxlength">
                                {{'MFMB_NO_REQUIRED_NO_IS_SHOULD_BE_OF_12_DIGITS' |
                                translate}}</div>
                        </div>
                    </div>

                    <div class="field col-12 md:col-4">
                        <label htmlFor="block">{{'PPP_ID' | translate}}</label>
                        <input maxlength="8" formControlName="pppId" pInputText id="block" type="text"
                            [ngClass]="{ 'ng-invalid ng-dirty': updatePersonalDetailsForm.controls['pppId'].invalid && updatePersonalDetailsForm.controls['pppId'].touched }" />
                        <div *ngIf="updatePersonalDetailsForm.controls['pppId'].invalid && updatePersonalDetailsForm.controls['pppId'].touched"
                            class="invalid-feedback">
                            <div *ngIf="updatePersonalDetailsForm.controls['pppId'].errors.required">{{'PPP_ID_IS_REQUIRED' |
                                translate}}</div>
                            <div *ngIf="updatePersonalDetailsForm.controls['pppId'].errors.minlength">
                                {{'PPP_ID_SHOULD_BE_OF_8DIGITS' | translate}}</div>
                            <div *ngIf="updatePersonalDetailsForm.controls['pppId'].errors.maxlength">
                                {{'PPP_ID_SHOULD_BE_OF_8DIGITS' | translate}}</div>
                        </div>
                    </div>

                    <div class="field col-12 md:col-4">
                        <label htmlFor="block">{{'CASTE' | translate}}</label>
                        <div class="formgroup-inline">
                            <div class="field">
                                <div class="field-radiobutton mb-0">
                                    <p-radioButton formControlName="casteCode" value="1"
                                        id="IsSubsidyAvailabeYes"></p-radioButton>
                                    <label for="IsSubsidyAvailabeYes">{{'GEN' | translate}}</label>
                                </div>
                            </div>
                            <div class="field">
                                <div class="field-radiobutton mb-0">
                                    <p-radioButton formControlName="casteCode" value="2"
                                        id="IsSubsidyAvailabeYes"></p-radioButton>
                                    <label for="IsSubsidyAvailabeYes">{{'BC' | translate}}</label>
                                </div>
                            </div>
                            <div class="field">
                                <div class="field-radiobutton mb-0">
                                    <p-radioButton formControlName="casteCode" value="3"
                                        id="IsSubsidyAvailabeNo"></p-radioButton>
                                    <label for="IsSubsidyAvailabeNo">{{'SC/ST' | translate}}</label>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="updatePersonalDetailsForm.controls['casteCode'].invalid && updatePersonalDetailsForm.controls['casteCode'].touched"
                            class="invalid-feedback">
                            <div *ngIf="updatePersonalDetailsForm.controls['casteCode'].errors.required">
                                {{'CASTE_IS_REQUIRED'| translate}}</div>
                        </div>
                    </div>

                    <div class="field col-12 md:col-4">
                        <label htmlFor="villageCode">{{'VILLAGE' | translate}}</label>
                        <p-autoComplete formControlName="villageCode" placeholder="{{'SEARCH'| translate}}" id="dd"
                            [dropdown]="true" [multiple]="false" [suggestions]="filteredVillage"
                            (completeMethod)="filterVillage($event)" field="Name" value="Code"
                            [ngClass]="{ 'ng-invalid ng-dirty': updatePersonalDetailsForm.controls['villageCode'].touched  && updatePersonalDetailsForm.controls['villageCode'].errors }"></p-autoComplete>

                        <div *ngIf="updatePersonalDetailsForm.controls['villageCode'].invalid && updatePersonalDetailsForm.controls['villageCode'].touched"
                            class="p-error">
                            {{'VILLAGE_NAME_IS_REQUIRED' | translate}}
                        </div>
                    </div>

                    <div class="field col-12 md:col-4">
                        <label htmlFor="component">{{'PROPOSED_SYETEM_TO_BE_INSTALLED'| translate}}</label>
                        <p-dropdown [options]="componentMasterList" appendTo="body" formControlName="componentMaster"
                            placeholder="{{'SEARCH'| translate}}" optionLabel="Program_Name" optionValue="Program_Id"
                            [ngClass]="{ 'g-invalid ng-dirty': updatePersonalDetailsForm.controls['componentMaster'].invalid && updatePersonalDetailsForm.controls['componentMaster'].touched }"></p-dropdown>
                        <div *ngIf="updatePersonalDetailsForm.controls['componentMaster'].invalid && updatePersonalDetailsForm.controls['componentMaster'].touched"
                            class="invalid-feedback">
                            <div *ngIf="updatePersonalDetailsForm.controls['componentMaster'].errors.required">
                                {{'PROPOSED_SYETEM_IS_REQUIRED'| translate}}</div>
                        </div>
                    </div>

                    <div class="field col-12 md:col-4">
                        <label htmlFor="component">{{'CATEGORY_OF_FARMER'| translate}}</label>
                        <p-dropdown [options]="farmerCategoryList" appendTo="body" formControlName="farmerCategory"
                            placeholder="{{'SEARCH'| translate}}" optionLabel="Type" optionValue="AutoID"
                            [ngClass]="{ 'g-invalid ng-dirty': updatePersonalDetailsForm.controls['farmerCategory'].invalid && updatePersonalDetailsForm.controls['farmerCategory'].touched }"></p-dropdown>
                        <div *ngIf="updatePersonalDetailsForm.controls['farmerCategory'].invalid && updatePersonalDetailsForm.controls['farmerCategory'].touched"
                            class="invalid-feedback">
                            <div *ngIf="updatePersonalDetailsForm.controls['farmerCategory'].errors.required">
                                {{'COMPONENT_MASTER_IS_REQUIRED'| translate}}</div>
                        </div>
                    </div>

                    <div class="field col-12 md:col-4">
                        <label htmlFor="block">{{'AADHAR_NUMBER' | translate}}</label>
                        <input maxlength="12" pattern="^[0-9]{12}$" pKeyFilter="int" formControlName="aadharNo"
                            pInputText id="block" type="text" (input)="checkAadharNumber($event)"
                            [ngClass]="{ 'ng-invalid ng-dirty': updatePersonalDetailsForm.controls['aadharNo'].invalid && updatePersonalDetailsForm.controls['aadharNo'].touched }" />

                        <div *ngIf="updatePersonalDetailsForm.controls['aadharNo'].invalid && updatePersonalDetailsForm.controls['aadharNo'].touched"
                            class="invalid-feedback">
                            <div *ngIf="updatePersonalDetailsForm.controls['aadharNo'].errors.required">
                                {{'AADHAR_NO_IS_REQUIRED'
                                | translate}}</div>
                            <div *ngIf="updatePersonalDetailsForm.controls['aadharNo'].errors.minlength">
                                {{'AADHAR_NO_IS_SHOULD_BE_OF_12_DIGITS' |
                                translate}}</div>
                            <div *ngIf="updatePersonalDetailsForm.controls['aadharNo'].errors.maxlength">
                                {{'AADHAR_NO_IS_SHOULD_BE_OF_12_DIGITS' |
                                translate}}</div>
                        </div>
                    </div>

                    <div class="field col-12 md:col-5">
                        <label for="name" class="ml-2">{{'AADHAR_PHOTO' | translate}}</label>
                        <p-fileUpload accept=".jpeg,.pdf,.jpg" [customUpload]="true" #farmerAadharDocUpload
                            (uploadHandler)="onUpdateAadharUpload($event, 'aadharPhotoPath', farmerAadharDocUpload)"
                            name="myfile[]" [maxFileSize]="5000000" [multiple]="false"
                            chooseLabel="{{'CHOOSE'| translate}}" [auto]="false" [showCancelButton]="false">
                            <ng-template pTemplate="content">
                                <p-image *ngIf="updatePersonalDetailsForm.controls['aadharPhotoPath'].value"
                                    [src]="updatePersonalDetailsForm.controls['aadharPhotoPath'].value" alt="Image"
                                    width="60" class="ml-2" iconPos="left"></p-image>
                                <!-- <ul *ngIf="uploadedAadharFiles.length">
                                    <li *ngFor="let file of uploadedAadharFiles">
                                        <p-image *ngIf="updatePersonalDetailsForm.controls['aadharPhotoPath'].value"
                                            [src]="updatePersonalDetailsForm.controls['aadharPhotoPath'].value" alt="Image"
                                            width="60" class="ml-2" iconPos="left"></p-image>
                                        {{ file.name }} - {{ file.size }} bytes
                                    </li>
                                </ul> -->
                            </ng-template>
                        </p-fileUpload>
                        <div *ngIf="updatePersonalDetailsForm.controls['aadharPhotoPath'].invalid && updatePersonalDetailsForm.controls['aadharPhotoPath'].touched"
                            class="invalid-feedback">
                            <div *ngIf="updatePersonalDetailsForm.controls['aadharPhotoPath'].errors.required">
                                {{'AADHAR_PHOTO_IS_REQUIRED' | translate}}
                            </div>
                        </div>
                    </div>

                    <div class="field col-12 md:col-3">
                        <label htmlFor="block">{{'IS_SUBSIDY_AVAILED' | translate}}</label>
                        <div class="formgroup-inline">
                            <div class="field">
                                <div class="field-radiobutton mb-0">
                                    <p-radioButton formControlName="isSubsidyAvailabe" value="1"
                                        id="isSubsidyAvailabeYes" (onClick)="onSelectSubsidyAvailUpdate('1')"></p-radioButton>
                                    <label for="IsSubsidyAvailabeYes">{{'YES' | translate}}</label>
                                </div>
                            </div>
                            <div class="field">
                                <div class="field-radiobutton mb-0">
                                    <p-radioButton formControlName="isSubsidyAvailabe" value="0"
                                        id="IsSubsidyAvailabeNo" (onClick)="onSelectSubsidyAvailUpdate('0')"></p-radioButton>
                                    <label for="IsSubsidyAvailabeNo">{{'NO' | translate}}</label>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="updatePersonalDetailsForm.controls['isSubsidyAvailabe'].invalid && updatePersonalDetailsForm.controls['isSubsidyAvailabe'].touched"
                            class="invalid-feedback">
                            <div *ngIf="updatePersonalDetailsForm.controls['isSubsidyAvailabe'].errors.required">
                                {{'IS_SUBSIDY_AVAILED_IS_REQUIRED'| translate}}</div>
                        </div>
                    </div>

                    <div *ngIf="updatePersonalDetailsForm.controls['isSubsidyAvailabe'].value == 1"
                        class="field col-12 md:col-4">
                        <label htmlFor="component">{{'SYETEM_INSTALLED_(DRIP/MINI/PORTABLE)'| translate}}</label>
                        
                        <p-dropdown [options]="componentMasterList" appendTo="body" formControlName="installedSystem"
                        placeholder="{{'SELECT_SYSTEM_INSTALLED'| translate}}" optionLabel="Program_Name" optionValue="Program_Id"
                        [ngClass]="{ 'g-invalid ng-dirty': updatePersonalDetailsForm.controls['installedSystem'].invalid && updatePersonalDetailsForm.controls['installedSystem'].touched }"></p-dropdown>

                        <div *ngIf="updatePersonalDetailsForm.controls['installedSystem'].invalid && updatePersonalDetailsForm.controls['installedSystem'].touched"
                            class="invalid-feedback">
                            <div *ngIf="updatePersonalDetailsForm.controls['installedSystem'].errors.required">
                                {{'SYETEM_INSTALLED_IS_REQUIRED'| translate}}</div>
                        </div>
                    </div>

                    <div *ngIf="updatePersonalDetailsForm.controls['isSubsidyAvailabe'].value == 1"
                        class="field col-12 md:col-4">
                        <label htmlFor="yearSubsudy">{{'YEAR'| translate}}</label>
                        <p-dropdown [options]="yearArray" formControlName="yearSubsudy" optionValue="name"
                            optionLabel="name" appendTo="body" placeholder="{{'SELECT_YEAR'| translate}}">
                        </p-dropdown>

                        <div *ngIf="updatePersonalDetailsForm.controls['yearSubsudy'].invalid && updatePersonalDetailsForm.controls['yearSubsudy'].touched"
                            class="invalid-feedback">
                            <div *ngIf="updatePersonalDetailsForm.controls['yearSubsudy'].errors.required">
                                {{'YEAR_IS_REQUIRED'|
                                translate}}</div>
                        </div>
                    </div>

                    <div *ngIf="updatePersonalDetailsForm.controls['isSubsidyAvailabe'].value == 1"
                        class="field col-12 md:col-3">
                        <label htmlFor="block">{{'ON_COST_SUBSIDY_BASED' | translate}}</label>
                        <div class="formgroup-inline">
                            <div class="field">
                                <div class="field-radiobutton mb-0">
                                    <p-radioButton formControlName="onCostSubsidyBased" value="1"
                                        id="onCostSubsidyBasedYes" (onClick)="onSelectOnCostS('1')"></p-radioButton>
                                    <label for="onCostSubsidyBasedYes">{{'YES' | translate}}</label>
                                </div>
                            </div>
                            <div class="field">
                                <div class="field-radiobutton mb-0">
                                    <p-radioButton formControlName="onCostSubsidyBased" value="0"
                                        id="onCostSubsidyBasedNo" (onClick)="onSelectOnCostS('0')"></p-radioButton>
                                    <label for="onCostSubsidyBasedNo">{{'NO' | translate}}</label>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="updatePersonalDetailsForm.controls['onCostSubsidyBased'].invalid && updatePersonalDetailsForm.controls['onCostSubsidyBased'].touched"
                            class="invalid-feedback">
                            <div *ngIf="updatePersonalDetailsForm.controls['onCostSubsidyBased'].errors.required">
                                {{'IS_SUBSIDY_AVAILED_IS_REQUIRED'| translate}}</div>
                        </div>
                    </div>

                    <div *ngIf="(updatePersonalDetailsForm.controls['isSubsidyAvailabe'].value == 1 && updatePersonalDetailsForm.controls['onCostSubsidyBased'].value == 1)"
                        class="field col-12 md:col-4">
                        <label htmlFor="departmentSubsidy">{{'DEPARTMENT'| translate}}</label>
                        <p-dropdown [options]="departmentList" formControlName="departmentSubsidy" optionValue="name"
                            optionLabel="name" appendTo="body" placeholder="{{'SELECT_DEPARTMENT'| translate}}">
                        </p-dropdown>

                        <div *ngIf="updatePersonalDetailsForm.controls['departmentSubsidy'].invalid && updatePersonalDetailsForm.controls['departmentSubsidy'].touched"
                            class="invalid-feedback">
                            <div *ngIf="updatePersonalDetailsForm.controls['departmentSubsidy'].errors.required">
                                {{'DEPARTMANT_IS_REQUIRED'| translate}}</div>
                        </div>
                    </div>

                    
                    <div class="field col-12 md:col-12">
                        <!-- <button pButton pRipple type="button" type="submit" label="{{'Update' | translate}}"
                        class="p-button-primary mr-2 mb-2" style="width: 90px; height: 32px; align-items: center;"></button> -->
                        <div class="button-container" *ngIf="farmerPastSubsidyList.length == 0">
                            <button class="justify-content-center p-button-success" pButton type="submit" label="{{'UPDATE' | translate}}" style="width: 70%; height: 32px;"></button>
                        </div>
                    </div>
                </div>     
            </form>

            <div *ngIf="farmerPastSubsidyList.length > 0" class="p-fluid mt-2 card land-details-card">
                <h5 style="color:rgb(97, 27, 27); font-size: '1.0rem'; font-weight: bold;" class="px-3">
                    {{'PAST_SUBSIDY_LIST'| translate}}{{ personalDetailsForm.controls['aadharNo'].value }}</h5>
                <p-table #farmerPastSubsidyTable [value]="farmerPastSubsidyList" [rows]="10" [paginator]="true"
                    [globalFilterFields]="[
                'AadharNo',
                'AppId',
                'Area',
                'LandDetail', 
                'System',
                'SubsidyYear', 
                'Department',
                'DiffYear', 
                ]" [rowHover]="true" dataKey="id"
                    currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                    [showCurrentPageReport]="true" responsiveLayout="scroll">
                    <ng-template pTemplate="header">
                        <tr>
                            <!-- <th>{{'AADHAR_NO'| translate}}</th> -->
                            <th>{{'APP_ID'| translate}}</th>
                            <th>{{'AREA'| translate}}</th>
                            <th>{{'LAND_DETAILS'| translate}}</th>
                            <th>{{'SYSTEM'| translate}}</th>
                            <th>{{'SUBSIDY_YEAR'| translate}}</th>
                            <th>{{'DEPARTMENT'| translate}}</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-product let-i="rowIndex">
                        <tr>
                            <!-- <td>{{product?.AadharNo}}</td> -->
                            <td>{{product?.AppId}}</td>
                            <td>{{product?.Area}}</td>
                            <td>{{product?.LandDetail}}</td>
                            <td>{{product?.System}}</td>
                            <td>{{product?.SubsidyYear}}</td>
                            <td>{{product?.Department}}</td>
                        </tr>
                    </ng-template>
                </p-table>

                <h5 *ngIf="farmerPastSubsidyList.length > 0" style="color:rgb(249, 55, 55); font-size: '1.2rem'; font-weight: bold; font-family: 'Times New Roman', Times, serif;"
                    class="px-3">
                    {{'SHOW_INVALID_FARMER_MSG'| translate}} {{ personalDetailsForm.controls['aadharNo'].value }} {{
                    'CAN_NOT_PROCEED' | translate}}</h5>
                </div>
        </div>
    <!-- </div> -->




    <!-- <button pButton pRipple type="button" label="{{'SUBMIT'| translate}}" class="p-button-success m-2"
        style="float: right;" (click)="submitSurveyDetails()"></button> -->
</p-dialog>

<p-confirmDialog [style]="{width: '400px'}"></p-confirmDialog>